<template>
  <div
    class="ts-flex ts-flex-col ts-h-full ts-relative ts-py-1 ts-pt-3 ts-pr-3"
  >
    <div class="ts-space-y-3 ts-sticky ts-top-0 ts-bg-white ts-z-10">
      <a-input-search
        :placeholder="$t('paymentNotice.studentSearch')"
        class="ts-w-full"
        @search="onSearch"
        :loading="searching"
      />
    </div>
    <div class="ts-py-3 ">
      <div
        class="ts-px-1 ts-py-2 ts-whitespace-no-wrap ts-cursor-pointer 
          hover:ts-bg-gray-100 ts-duration-150 ts-transform focus:ts-bg-blue-500"
        v-for="(student, i) in students"
        :key="i"
        :class="{ 'ts-border-b': i !== students.length - 1 }"
        @click="onSelectedStudent(student)"
      >
        <div class="student-grid">
          <div class="ts-overflow-hidden">
            <p
              class="ts-whitespace-no-wrap ts-bg-blue-100 ts-text-blue-500 ts-px-1 ts-rounded-md"
            >
              <b>{{ student.full_name_en }}</b>
            </p>
            <p class="ts-whitespace-no-wrap"># {{ student.card_number }}</p>
          </div>
          <div>
            <p>
              <b>{{ $t('paymentNotice.sex') }}</b>
            </p>
            <p>{{ student.gender }}</p>
          </div>
          <div>
            <p>
              <b>{{ $t('paymentNotice.batch') }}</b>
            </p>
            <p>{{ student.promotion }}</p>
          </div>
        </div>
        <p class="ts-mt-2">{{ student.acps_name_foreign }}</p>
      </div>
    </div>
    <div class="ts-flex-1 ts-border-blue-600 ts-py-3" v-if="!students.length">
      <div
        class="ts-h-full ts-w-full ts-flex ts-items-center ts-justify-center"
      >
        <div class="ts-text-center ts-text-gray-300">
          <i class="fas fa-folder-open fa-3x"></i>
          <h1 class="ts-mt-2 ts-font-bold ts-uppercase ts-text-gray-300">
            {{ $t('noData') }}
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'studentListV2',
  props: ['value'],
  data() {
    return {
      searching: false,
      students: []
    }
  },
  created() {
    this.model = this.value
  },
  mounted() {
    if (!this.$route.params.id) {
      this.onSearch('')
    }
  },
  methods: {
    ...mapActions('paymentNoticeModule', ['onGetStudent']),
    ...mapMutations('paymentNoticeModule', ['SET_SELECTED_STUDENT']),
    onSearch(search) {
      this.searching = true
      this.students = []
      this.onGetStudent({
        search
      })
        .then(response => {
          this.students = response.data.data
        })
        .catch(error => {
          this.$toasted.error(error.response.data.message)
        })
        .finally(() => (this.searching = false))
    },
    onSelectedStudent(student) {
      this.SET_SELECTED_STUDENT(student)
      this.$emit('selected', student)
    }
  }
}
</script>

<style>
.student-grid {
  display: grid;
  grid-template-columns: 200px 130px 130px;
  column-gap: 8px;
}
</style>
